import { useAppDispatch, useAppSelector } from './state'
import {
  getMemberBenefits as getMemberBenefitsAPI,
  getMemberBenefit as getMemberBenefitAPI,
  joinCampaign as joinCampaignAPI,
  getDiscountCode as getDiscountCodeAPI,
  vote as voteApi
} from '../api/member_benefits'
import {
  setMemberBenefits,
  setMemberBenefit,
  setIsMemberBenefitLoading
} from '../state/slices/member_benefit_slice'
import { useEffect } from 'react'
import { getResourceAuthorization } from '../state/selectors/resource_authorization'
import he from 'he'

export const useMemberBenefits = (id?: string, options?: { enabled?: boolean }) => {
  const dispatch = useAppDispatch()
  const currentResourceAuthorization = useAppSelector(getResourceAuthorization)
  const enabled = options?.enabled ?? true

  useEffect(() => {
    if (id && enabled) {
      getMemberBenefit(id)
    }
  }, [enabled, id])

  const getMemberBenefits = async () => {
    if (!enabled) {
      return false
    }

    dispatch(setIsMemberBenefitLoading(true))

    const refKey = currentResourceAuthorization?.relationInfo?.agentNumber ?? ''
    const relationNumber = currentResourceAuthorization?.relationInfo?.relationNumber ?? ''

    if (!relationNumber || !refKey) {
      dispatch(setIsMemberBenefitLoading(false))

      return
    }

    try {
      const result = await getMemberBenefitsAPI(relationNumber, refKey)

      if (result.data) {
        result.data.memberbenefits.forEach(benefit => {
          benefit.content = he.decode(benefit.content ?? '')
        })

        dispatch(setMemberBenefits(result.data.memberbenefits))
      }

      return true
    } catch (e) {
      return false
    } finally {

      dispatch(setIsMemberBenefitLoading(false))
    }
  }

  const getMemberBenefit = async (id: string) => {
    dispatch(setIsMemberBenefitLoading(true))

    const refKey = currentResourceAuthorization?.relationInfo?.agentNumber ?? ''
    const relationNumber = currentResourceAuthorization?.relationInfo?.relationNumber ?? ''

    if (!relationNumber || !refKey) {
      dispatch(setIsMemberBenefitLoading(false))

      return
    }

    try {
      const result = await getMemberBenefitAPI(id, relationNumber, refKey)

      if (result.data) {
        result.data.memberBenefit.content = he.decode(result.data.memberBenefit.content ?? '')

        dispatch(setMemberBenefit(result.data.memberBenefit))
      }

      return true
    } catch (e) {
      return false
    } finally {
      dispatch(setIsMemberBenefitLoading(false))
    }
  }

  const joinCampaign = async (id: string) => {
    dispatch(setIsMemberBenefitLoading(true))

    const refKey = currentResourceAuthorization?.relationInfo?.agentNumber ?? ''
    const relationNumber = currentResourceAuthorization?.relationInfo?.relationNumber ?? ''

    if (!relationNumber || !refKey) {
      dispatch(setIsMemberBenefitLoading(false))

      return
    }

    try {
      const result = await joinCampaignAPI(id, relationNumber, refKey)

      if (result.data) {
        result.data.memberBenefit.content = he.decode(result.data.memberBenefit.content ?? '')

        dispatch(setMemberBenefit(result.data.memberBenefit))
      }

      return true
    } catch (e) {
      return false
    } finally {
      dispatch(setIsMemberBenefitLoading(false))
    }
  }

  const getDiscountCode = async (id: string) => {
    dispatch(setIsMemberBenefitLoading(true))

    const refKey = currentResourceAuthorization?.relationInfo?.agentNumber ?? ''
    const relationNumber = currentResourceAuthorization?.relationInfo?.relationNumber ?? ''

    if (!relationNumber || !refKey) {
      dispatch(setIsMemberBenefitLoading(false))

      return
    }

    try {
      const result = await getDiscountCodeAPI(id, relationNumber, refKey)

      if (result.data) {
        result.data.memberBenefit.content = he.decode(result.data.memberBenefit.content ?? '')

        dispatch(setMemberBenefit(result.data.memberBenefit))
      }

      return true
    } catch (e) {
      return false
    } finally {
      dispatch(setIsMemberBenefitLoading(false))
    }
  }

  const vote = async (id: string, voteItemId: number) => {
    dispatch(setIsMemberBenefitLoading(true))

    const refKey = currentResourceAuthorization?.relationInfo?.agentNumber ?? ''
    const relationNumber = currentResourceAuthorization?.relationInfo?.relationNumber ?? ''

    if (!relationNumber || !refKey) {
      dispatch(setIsMemberBenefitLoading(false))

      return
    }

    try {
      const result = await voteApi(id, voteItemId, relationNumber, refKey)

      if (result.data) {
        result.data.memberBenefit.content = he.decode(result.data.memberBenefit.content ?? '')

        dispatch(setMemberBenefit(result.data.memberBenefit))
      }

      return true
    } catch (e) {
      return false
    } finally {
      dispatch(setIsMemberBenefitLoading(false))
    }
  }

  return {
    getMemberBenefits,
    getMemberBenefit,
    joinCampaign,
    getDiscountCode,
    vote
  }
}

export default useMemberBenefits
